import React, { useEffect, useState } from 'react';
import RedQuickOrderedList from './RedQuickOrderedList';
import { CoherentScreen, CuratedMediaList } from 'models';
import { CuratedMediaListEditor } from './CuratedMediaListEditor';
import { Button, Dialog } from '@mui/material';
import CoherentScreenMediaSelectionDialog from './CoherentScreenMediaSelectionDialog';
import { get_all_media } from 'features/media/media-slice';
import { useSelector } from 'react-redux';
import RedQuickTextField from './RedQuickTextField';
export interface CoherentScreenConfig {
    id: string;
    name: string;
    lists: CuratedMediaList[];
}
interface CoherentScreenEditorProps {
    screen: CoherentScreenConfig;
    onChange: (screen: CoherentScreenConfig) => void;
}

const CoherentScreenEditor: React.FC<CoherentScreenEditorProps> = ({ screen, onChange }) => {
    const [screen_list, setScreenList] = useState<{ data: CuratedMediaList, i: any }[]>([]);
    const [curatedMediaList, setCuratedMediaList] = useState<CuratedMediaList>(null);
    const media_list = useSelector(get_all_media);
    const handleListChange = (i: string, newList: CuratedMediaList) => {
        const newScreen = {
            ...screen,
            lists: screen.lists.map((list, idx) => (list.id === i ? newList : list))
        };
        onChange(newScreen);
    };

    // Function to handle adding a new CuratedMediaList
    const handleAddList = () => {
        const newList: CuratedMediaList = {
            id: Date.now().toString(), // generating a pseudo-unique ID based on timestamp
            name: "New List", // default name
            processedMedia: [],
            media: []
        } as any;
        const newScreen: CoherentScreenConfig = {
            ...screen,
            lists: [...screen.lists, newList]
        };
        onChange(newScreen);
    };

    useEffect(() => {
        if (screen) {
            setScreenList(screen.lists.map((item) => {
                return ({
                    id: item.id,
                    i: item.id,
                    data: item
                })
            }))
        }
    }, [JSON.stringify(screen)])

    return (
        <div>
            <CoherentScreenMediaSelectionDialog
                curatedMediaList={curatedMediaList}
                open={!!curatedMediaList}
                onAddProcessedMediaItems={(medias) => {
                    let updated = { ...curatedMediaList };
                    updated.media = [...medias.map(media => {
                        return media_list.find(d => d.id === media);
                    })];

                    const newScreen: CoherentScreenConfig = {
                        ...screen,
                        lists: [...screen.lists.map(v => {
                            if (v.id === curatedMediaList.id) {
                                return updated;
                            }
                            return v;
                        })]
                    };
                    onChange(newScreen);
                }}
                onClose={() => {
                    setCuratedMediaList(null);
                }}
            />
            <div style={{ paddingBottom: 20 }}>
                <Button onClick={handleAddList}>Add New Group</Button>
            </div>
            {screen.lists.map((data) => {
                console.log(data);
                return (
                    <div style={{ paddingBottom: 20 }}>
                        <CuratedMediaListEditor list={data}
                            contextId={data?.id}
                            onChange={(newList) => {
                                handleListChange(data.id, newList)
                            }}
                            onAddMedia={(curatedMediaList) => {
                                setCuratedMediaList(curatedMediaList);
                            }}
                        />
                    </div>
                )
            })}
        </div>
    );
};

export default CoherentScreenEditor;
